<div class="modal-backdrop" *ngIf="show" (click)="close()"></div>

<div class="modal-container" *ngIf="show">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div class="modal-header">
      <div class="modal-title">
        <i class="fas fa-user"></i>
        <h2>Detalhes do Usuário</h2>
      </div>
      <button class="btn-close" (click)="close()" type="button">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <!-- Body -->
    <div class="modal-body" *ngIf="user">
      <div class="user-header">
        <div class="user-avatar">
          <ng-container *ngIf="avatarDataUrl; else defaultAvatar">
            <img class="avatar-img" [src]="avatarDataUrl" alt="Avatar do usuário" />
          </ng-container>
          <ng-template #defaultAvatar>
            <i class="fas fa-user-circle"></i>
          </ng-template>
        </div>
        <div class="user-main-info">
          <div class="user-name">{{ user.name || '-' }}</div>
          <div class="user-email">
            <i class="fas fa-envelope"></i>
            <span>{{ user.email || '-' }}</span>
          </div>
          <div class="user-badges">
            <span [ngClass]="getStatusBadgeClass(user.active)">
              {{ user.statusDisplay || (user.active ? 'Ativo' : 'Inativo') }}
            </span>
            <span [ngClass]="getClientBadgeClass(user.isClient)">
              {{ user.clientDisplay || (user.isClient ? 'Cliente' : 'Funcionário') }}
            </span>
          </div>
        </div>
      </div>

      <div class="user-details-grid">
        <div class="detail-card">
          <h3>
            <i class="fas fa-id-badge"></i>
            Informações Gerais
          </h3>
          <div class="detail-row">
            <span class="label">Perfil</span>
            <span class="value">{{ user.profileDisplay || 'Sem perfil' }}</span>
          </div>
          <div class="detail-row" *ngIf="user.employeeType">
            <span class="label">Tipo de Contrato</span>
            <span class="value">{{ user.employeeType }}</span>
          </div>
          <div class="detail-row" *ngIf="user.createdAtDisplay">
            <span class="label">Criado em</span>
            <span class="value">{{ user.createdAtDisplay }}</span>
          </div>
        </div>

        <div class="detail-card">
          <h3>
            <i class="fas fa-briefcase"></i>
            Funcionário
          </h3>
          <div class="detail-row">
            <span class="label">Funcionário Vinculado</span>
            <span class="value">{{ user.staffDisplay || '-' }}</span>
          </div>
          <div class="detail-row">
            <span class="label">Bloqueado</span>
            <span class="value">{{ user.blockedDisplay || (user.blocked ? 'Sim' : 'Não') }}</span>
          </div>
        </div>
      </div>

      <div class="detail-card temp-password-card" *ngIf="canEditUsers" [class.is-active]="showTempPasswordPanel">
        <div class="temp-password-header">
          <div class="form-check form-switch">
            <input
              class="form-check-input"
              type="checkbox"
              id="showTempPasswordPanel"
              [(ngModel)]="showTempPasswordPanel"
              (ngModelChange)="onTempPasswordPanelChange($event)"
              [disabled]="settingTempPassword">
            <label class="form-check-label" for="showTempPasswordPanel">
              <i class="fas fa-key"></i>
              Definir senha temporária
            </label>
          </div>
          <i
            class="fas fa-info-circle temp-password-info-icon"
            title="Define uma senha provisória. O usuário será obrigado a alterá-la no próximo login.">
          </i>
        </div>

        <div class="temp-password-panel" [class.is-open]="showTempPasswordPanel">
          <div class="temp-password-info">
            <i class="fas fa-shield-alt"></i>
            <span>No próximo login, o usuário será redirecionado para definir uma nova senha.</span>
          </div>

          <div class="form-check form-switch temp-password-sub-switch">
            <input
              class="form-check-input"
              type="checkbox"
              id="useDefaultTempPassword"
              [(ngModel)]="useDefaultTempPassword"
              (ngModelChange)="onDefaultTempPasswordChange($event)"
              [disabled]="settingTempPassword">
            <label class="form-check-label" for="useDefaultTempPassword">
              Usar senha padrão do sistema
              <span class="default-password-badge">{{ defaultTempPassword }}</span>
            </label>
          </div>

          <div class="temp-password-field">
            <label for="tempPassword">Senha temporária</label>
            <div class="password-input-row">
              <input
                [type]="showTempPassword ? 'text' : 'password'"
                id="tempPassword"
                class="form-control"
                [(ngModel)]="tempPassword"
                [disabled]="settingTempPassword || useDefaultTempPassword"
                [class.input-disabled]="useDefaultTempPassword"
                placeholder="Digite a senha temporária">
              <button
                type="button"
                class="btn btn-toggle-password"
                (click)="toggleTempPasswordVisibility()"
                [disabled]="settingTempPassword || useDefaultTempPassword">
                <i class="fas" [ngClass]="showTempPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
              </button>
            </div>
          </div>

          <div class="temp-password-actions">
            <button
              class="btn btn-primary"
              type="button"
              (click)="setTemporaryPassword()"
              [disabled]="settingTempPassword || !tempPassword.trim()">
              <i class="fas fa-spinner fa-spin" *ngIf="settingTempPassword"></i>
              <i class="fas fa-check" *ngIf="!settingTempPassword"></i>
              {{ settingTempPassword ? 'Aplicando...' : 'Aplicar senha temporária' }}
            </button>
          </div>

          <div class="alert alert-success mb-0" *ngIf="tempPasswordMessage">
            <i class="fas fa-check-circle me-2"></i>
            {{ tempPasswordMessage }}
          </div>
          <div class="alert alert-danger mb-0" *ngIf="tempPasswordError">
            <i class="fas fa-exclamation-triangle me-2"></i>
            {{ tempPasswordError }}
          </div>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div class="modal-body" *ngIf="!user">
      <div class="empty-user">
        <i class="fas fa-user-slash"></i>
        <p>Nenhum usuário selecionado</p>
      </div>
    </div>

    <!-- Footer -->
    <div class="modal-footer">
      <button class="btn btn-secondary" (click)="close()" type="button">
        <i class="fas fa-times"></i>
        Fechar
      </button>
    </div>
  </div>
</div>
